module.exports = __webpack_public_path__ + "static/media/contacts-1.7ed09906.jpg";